import React from "react";

export class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      errorId: null,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
      errorId: `UI-${Date.now().toString(36).toUpperCase()}`,
    };
  }

  componentDidCatch(error, info) {
    try {
      console.error(
        "[SIMPLER UI ERROR]",
        error,
        info?.componentStack,
      );
    } catch {
      // Nunca permitir que o próprio logger gere outro erro.
    }
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch {
      window.location.href = "/";
    }
  };

  handleHome = () => {
    window.location.href = "/app";
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "#f8f8fb",
          color: "#18181b",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "460px",
            background: "#ffffff",
            border: "1px solid #e4e4e7",
            borderRadius: "18px",
            padding: "28px",
          }}
        >
          <div
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "18px",
              background: "#6d46d9",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: "20px",
            }}
          >
            S
          </div>

          <h1
            style={{
              margin: 0,
              fontSize: "20px",
              lineHeight: 1.3,
            }}
          >
            Não foi possível carregar esta tela
          </h1>

          <p
            style={{
              margin: "10px 0 0",
              color: "#71717a",
              fontSize: "14px",
              lineHeight: 1.6,
            }}
          >
            A Simpler protegeu sua sessão porque ocorreu
            um erro na interface. Seus dados não foram
            alterados.
          </p>

          <div
            style={{
              marginTop: "8px",
              color: "#a1a1aa",
              fontSize: "11px",
            }}
          >
            Código: {this.state.errorId}
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "22px",
            }}
          >
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                flex: 1,
                border: 0,
                borderRadius: "9px",
                padding: "11px 14px",
                background: "#6d46d9",
                color: "#ffffff",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Tentar novamente
            </button>

            <button
              type="button"
              onClick={this.handleHome}
              style={{
                flex: 1,
                border: "1px solid #d4d4d8",
                borderRadius: "9px",
                padding: "11px 14px",
                background: "#ffffff",
                color: "#27272a",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Ir para o início
            </button>
          </div>
        </div>
      </div>
    );
  }
}
